import { createContext, useState, useEffect } from "react";
import ReactGA from "react-ga4";

export const ModalContext = createContext<any>(null);

interface IContext {
  children: React.ReactNode;
}

export const ModalProvider = ({ children }: IContext) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const url = window.location.search.split("?")[1];
    window.addEventListener("message", (e) => {
      if (e.data === "tryadviser_open_modal") {
        window.parent.postMessage("expand", url);

        setModalOpen(true);
      }
    });
  }, []);

  const close = () => {
    if (!window.sessionStorage.getItem("tryadviser-closed")) {
      ReactGA.event({
        category: "Recomendador",
        action: "Cerrar Recomendador",
        label: "cerrar_recomendador",
      });

      window.sessionStorage.setItem("tryadviser-closed", "true");
    }

    setModalOpen(false);

    const url = window.location.search.split("?")[1];

    window.parent.postMessage("collapse", url);
  };

  const open = () => {
    setModalOpen(true);
  };

  return (
    <ModalContext.Provider value={[modalOpen, setModalOpen, open, close]}>
      {children}
    </ModalContext.Provider>
  );
};
